var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"streaming-text"},_vm._l((_vm.segments),function(segment,i){return _c('span',{key:segment.id,class:{ fade: segment.fade }},[_vm._v(_vm._s(segment.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }